import fetchManager from '@utils/fetchManager'
import { urlQueryData, getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");

export default {
  getListEvaluators: async (querys) => {
    const url = urlQueryData(`${API_URL}/ProcessManagement/api/amx/cpe/pdd/evaluators`, querys)
    const response = await fetchManager(url)
    return response
  },
  addEvaluator: async (data) => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/pdd/evaluators`, {
        method: 'POST',
        data,
      })
    return response
  },
  updateEvaluator: async (data) => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/pdd/evaluators`, {
        method: 'PATCH',
        data,
      })
    return response
  },
  reassignEvaluatorFolios: async (idEvaluator, data) => {
    const response = await fetchManager(
      `${API_URL}/ProcessManagement/api/amx/cpe/pdd/evaluators/${idEvaluator}/folios/reassignment`,
      {
        method: 'PATCH',
        data,
      }
    )
    return response
  },
  getListGestors: async (id,querys) => {
    const errorModal = { show: 'no' }
    const url = urlQueryData(`${API_URL}/ProcessManagement/api/amx/cpe/pdd/evaluators/${id}/managers`, querys)
    const response = await fetchManager(url, {}, errorModal)
    return response
  },
  addGestor: async (data) => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/pdd/evaluators/managers`, {
        method: 'POST',
        data,
      })
    return response
  },
  updateGestor: async (data, correo) => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/pdd/evaluators/managers/${correo}`, {
        method: 'PATCH',
        data,
      })
    return response
  },
  getListCoordinators: async (id,querys) => {
    const errorModal = { show: 'no' }
    const url = urlQueryData(`${API_URL}/ProcessManagement/api/amx/cpe/pdd/evaluators/${id}/coordinators`, querys)
    const response = await fetchManager(url, {}, errorModal)
    return response
  },
  addCoordinator: async (data) => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/pdd/evaluators/coordinators`, {
        method: 'POST',
        data,
      })
    return response
  },
  updateCoordinator: async (data, correo) => {
    const response = await fetchManager(`${API_URL}/ProcessManagement/api/amx/cpe/pdd/evaluators/coordinators/${correo}`, {
        method: 'PATCH',
        data,
      })
    return response
  },
}
